import ColorField from 'Shared/components/ColorField/ColorField'
import useAct from '../useAct'
import FontPicker from "font-picker-react";
import './Form.scoped.scss'
import LogoSetting from './LogoSetting'
import AudioSetting from './AudioSetting'

export default function BrandSettings() {
  const act = useAct()
  const {
    primaryColor,
    secondaryColor,
    logoLightBg,
    logoDarkBg,
    logoSquare,
    favicon,
    headerFont,
    bodyFont,
    customHomepageUrl,
    audioInboundOption,
    audioUnknownInbound
  } = useSel((s) => s.brand)

  const { validationErrors } = useSel((s) => s.local || {})


  const allowedAudioTypes = ['audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/wave']
  const audioTypeError = 'Please upload a valid audio file (MP3 or WAV format only)'


  return <div>
    <div className='box form'>
      <h2 className='no-margin-top'>URLs</h2>
      <div className="field">
        <label>Home webpage URL</label>
        <p className='small bold dark-grey'>This will be used anywhere supporters can navigate to your website, such as when clicking your logo.</p>
        <input
          type='text'
          className={`full-width margin-bottom ${validationErrors['customHomepageUrl'] ? 'invalid' : ''}`}
          value={customHomepageUrl}
          onChange={(e) => act.brand.upsert({ customHomepageUrl: e.target.value })}
        />
      </div>
    </div>

    <div className='box margin-top'>
      <h2 className='no-margin-top'>Colours</h2>
      <div className="fields-container form">
        <ColorField
          color={primaryColor || '#FFFFFF'}
          onChange={(val) => act.brand.upsert({ primaryColor: val })}
          label={'Primary Colour'}
        />
        <ColorField
          color={secondaryColor || '#FFFFFF'}
          onChange={(val) => act.brand.upsert({ secondaryColor: val })}
          label={'Secondary Colour'}
        />
      </div>
    </div>

    <div className='box margin-top'>
      <h2 className='no-margin-top'>Fonts</h2>
      <div className="fields-container form">
        <div className="field">
          <label className="margin-bottom half">Header Font</label>
          <FontPicker
            apiKey={window.ENV.GOOGLE_FONTS_API_KEY}
            activeFontFamily={headerFont}
            onChange={(val) => act.brand.upsert({ headerFont: val.family })}
            limit={500}
            pickerId="header"
          />
        </div>
        <div className="field">
          <label className="margin-bottom half">Paragraph Font</label>
          <FontPicker
            apiKey={window.ENV.GOOGLE_FONTS_API_KEY}
            activeFontFamily={bodyFont}
            onChange={(val) => act.brand.upsert({ bodyFont: val.family })}
            limit={500}
            pickerId="body"
          />
        </div>
      </div>
      <div className="font-preview">
        {headerFont && <h1 className="apply-font-header margin-bottom half larger no-margin-top">Font Preview (Header - {headerFont})</h1>}
        {bodyFont && <p className="apply-font-body no-margin-top">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in dui mauris. (Paragraph - {bodyFont})</p>}
      </div>
    </div>

    <div className='box margin-top form'>
      <h2 className='no-margin-top'>Logos</h2>
      <LogoSetting
        label="Logo (for display on light background)"
        value={logoLightBg}
        onUploaded={(val) => act.brand.upsert({ logoLightBg: val[0] })}
        helpText="Recommended aspect ratio of 5:1 and minimum width of 400px"
        className="light"
      />
      <LogoSetting
        label="Logo (for display on dark background)"
        value={logoDarkBg}
        onUploaded={(val) => act.brand.upsert({ logoDarkBg: val[0] })}
        helpText="Recommended aspect ratio of 5:1 and minimum width of 400px"
        className="dark"
      />
      <LogoSetting
        label="Logo (square)"
        value={logoSquare}
        onUploaded={(val) => act.brand.upsert({ logoSquare: val[0] })}
        helpText="Must be square (1:1 aspect ratio). Recommended minimum 400x400px dimensions."
        className="square"
      />
      <LogoSetting
        label="Favicon"
        value={favicon}
        onUploaded={(val) => act.brand.upsert({ favicon: val[0] })}
        helpText="Must be square (1:1 aspect ratio). Recommended minimum 48x48px dimensions."
        className="favicon"
      />
    </div>

    <div className='box margin-top form'>
      <h2 className='no-margin-top'>Voice recordings</h2>
      <p className='small bold dark-grey'>The following audio files are supported: .wav and .mp3</p>
      <AudioSetting
        label="Audio for Members or Supporters Calling in"
        value={audioInboundOption}
        onUploaded={(val) => act.brand.upsert({ audioInboundOption: val[0] })}
        helpText="Audio file that will be played when members or supporters call in"
        allowedTypes={allowedAudioTypes}
        fileTypeError={audioTypeError}
      />
      <AudioSetting
        label="Audio for Unknown Caller"
        value={audioUnknownInbound}
        onUploaded={(val) => act.brand.upsert({ audioUnknownInbound: val[0] })}
        helpText="Audio file that will be played when unknown callers call in"
        allowedTypes={allowedAudioTypes}
        fileTypeError={audioTypeError}
      />
    </div>
  </div>
};
